import { render, staticRenderFns } from "./NewGuestForm.vue?vue&type=template&id=4305234b&"
import script from "./NewGuestForm.vue?vue&type=script&lang=js&"
export * from "./NewGuestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports